import { accessToken, apiEndpoint, linkResolver } from 'prismic-config';
import Prismic from 'prismic-javascript';
import { Link } from 'react-router-dom';

export const customLink = (type, element, content, children, index) => (
    <Link to={linkResolver(element.data)} key={index}>
        {content}
    </Link>
);

export const client = Prismic.client(apiEndpoint, { accessToken })